import * as React from 'react'
import { parse, ParsedQs } from 'qs'
import { useLocation } from 'react-router-dom'
import sanitise from 'sanitize-html'

export default function useQuery(): ParsedQs {
  const { search } = useLocation()

  return React.useMemo(() => {
    const parsedQs = parse(search, { ignoreQueryPrefix: true })
    return Object.entries(parsedQs).reduce(
      (santisedQs: Record<string, string>, [key, value]) => {
        if (typeof value === 'string') {
          santisedQs[key] = sanitise(value, {
            allowedTags: [],
            disallowedTagsMode: 'recursiveEscape',
          })
        }
        return santisedQs
      },
      {},
    )
  }, [search])
}
